import {
    Modal
} from 'ant-design-vue';
import {
    createVNode
} from 'vue';
import {
    ExclamationCircleOutlined
} from '@ant-design/icons-vue';
import moment from 'moment'

export default {
    /**
     * 本地存储数据
     * */
    setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    /**
     * 获取本地缓存
     * */
    getItem(key) {
        const value = localStorage.getItem(key);
        if (value) {
            return JSON.parse(value);
        }
        return null;
    },
    /**
     * 删除某一个本地缓存
     * */
    remove(key) {
        localStorage.removeItem(key);
    },
    /**
     * 删除全部本地缓存
     * */
    clear() {
        localStorage.clear();
    },

    windowOpen(url) {
        const aElement = document.createElement('a');
        aElement.setAttribute('href', url)
        aElement.setAttribute('target', '_blank')
        document.body.appendChild(aElement)
        aElement.click()
        document.body.removeChild(aElement)
    },

    // 确认提示框
    showConfirmDialog(content, okCallback, cancelCallback) {
        Modal.confirm({
            centered: true,
            title: '温馨提示',
            icon: createVNode(ExclamationCircleOutlined),
            content: content,
            okText: '确定',
            cancelText: '取消',
            onOk() {
                if (okCallback) okCallback();
            },
            onCancel() {
                if (cancelCallback) cancelCallback();
            },
        });
    },
    /**
     * 格式化时间YYYY-MM-DD
     * @param {*} dataStr 
     */
    formatDate(dataStr) {
        if (dataStr === '') {
            return ''
        }
        return moment(dataStr * 1000).format('YYYY-MM-DD')
    },
    /**
     * 格式化时间YYYY-MM-DD HH:mm:ss
     * @param {*} dataStr 
     */
    formatDateTime(dataStr) {
        if (dataStr === '') {
            return ''
        }
        return moment(dataStr * 1000).format('YYYY-MM-DD HH:mm:ss')
    },

    formatDateTimeNew(dataStr) {
        if (dataStr === '') {
            return ''
        }
        return moment(dataStr).format('YYYY-MM-DD HH:mm:ss')
    },
}